// extracted by mini-css-extract-plugin
module.exports = {"container":"MyNfts_container__1gxW8","nftCard":"MyNfts_nftCard__2y5pa","img":"MyNfts_img__30QF8","card":"MyNfts_card__1_WPx"};